import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=078fc8f6&scoped=true&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=078fc8f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078fc8f6",
  null
  
)

export default component.exports